import _ from 'lodash'
import { createReducer, createAction } from 'redux-act'
import { push } from 'react-router-redux'
import axios from 'axios'
import qs from 'qs'
import l8n from 'l8n'

import { getUser, setFrom, setLoginFormHidden, addSubmitForm, deleteSubmitForm, removeUser, setToken } from './app'
import { baseUrl } from 'scripts/env'
import { getGaClientId } from 'scripts/analytics'

export const REDUCER = 'login'
const NS = `@@${REDUCER}/`

export const change = createAction(`${NS}CHANGE`)
export const reset = createAction(`${NS}RESET`)
export const googleSignInFailure = createAction(`${NS}SHOW_GOOGLE_SIGNIN_ERROR_MESSAGE`)
export const hideGoogleSignInErrorMessage = createAction(`${NS}HIDE_GOOGLE_SIGNIN_ERROR_MESSAGE`)
export const partnerLoggedIn = createAction(`${NS}PARTNER_LOGGED_IN`)

const initialState = {
    data: {
      email: { value: null },
      password: { value: null }
    },
    googleSignInErrorMessage: null,
}

const loginFailed = () => (dispatch) => {
  dispatch(push('/' + l8n.locale + '/login'))
  dispatch(setFrom(''))
}

export const login = async ({ email, password, dispatch, idToken }) => {
  const params = {
    login: email,
    password,
    googleIdToken: idToken,
    cid: getGaClientId(),
  }
  const response = await axios({
      method: 'POST',
      url: baseUrl + '/auth/access',
      data: qs.stringify(params)
  });

  let token = _.get(response, 'data.access_token', false)
  if (token === false) {
      dispatch(loginFailed())
      return false
  }

  axios.defaults.headers.common['Authorization'] = token;
  dispatch(setToken(token))

  const user_fetched = await dispatch(getUser())

  if (!user_fetched){
      dispatch(loginFailed())
      return false
  }

  const isGoogleSignIn = ! _.isEmpty(idToken)
  dispatch(partnerLoggedIn(isGoogleSignIn))

  dispatch(setLoginFormHidden(true))
  dispatch(push('/' + l8n.locale))
  return true
}

export const logout = () => async (dispatch) => {
    await axios({
        method: 'POST',
        url: baseUrl + '/auth/revoke'
    });

    dispatch(removeUser())
    dispatch(reset())
    //console.log('logout => /' + l8n.locale + '/login')
    dispatch(push('/' + l8n.locale + '/login'))
}

export const submit = ({ email, password }) => async (dispatch) => {
  dispatch(addSubmitForm(REDUCER))

  let logged = await login({ email, password, dispatch })
  if (logged) {
    dispatch(deleteSubmitForm(REDUCER))
  } else {
    dispatch(deleteSubmitForm(REDUCER))
  }
}

export const googleSignInSuccess = ({ idToken }) => async (dispatch) => {
  dispatch(hideGoogleSignInErrorMessage())

  await login({ idToken, dispatch });
}

export default createReducer(
  {
    [change]: (state, data) => ({ ...state, data: {...state.data, ...data}}),
    [reset]: (state, data) => ({ ...state, ...initialState }),
    [googleSignInFailure]: (state, msg) => ({ ...state, googleSignInErrorMessage: msg }),
    [hideGoogleSignInErrorMessage]: (state, data) => ({ ...state, googleSignInErrorMessage: null }),
  }, 
  initialState
)



// WEBPACK FOOTER //
// ./src/ducks/login.js